export default function ComingSoon() {
  return (
    <div className='py-24'>
      <div className='w-full flex'>
        <div className='flex-1 text-center py-10'>Coming soon</div>
      </div>
    </div>
  );
}
